var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isModalExistingGroupVisible,
          expression: "isModalExistingGroupVisible"
        }
      ]
    },
    [
      _c("transition", { attrs: { name: "slide" } }, [
        _c("div", { staticClass: "modal-mask" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-dialog-slideout modal-lg" },
            [
              _c("div", { staticClass: "modal-content p-2" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("div", { staticClass: "width-100" }, [
                    _c(
                      "a",
                      {
                        staticClass: "text-uppercase text-muted pt-1",
                        attrs: { href: "javascript:void(0);" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("img", {
                          staticClass: "back_icon mr-2",
                          attrs: {
                            src: require("@/assets/manager/back_button_icon.png")
                          }
                        }),
                        _vm._v("Back")
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "close float-right",
                        attrs: { type: "button" },
                        on: { click: _vm.hide }
                      },
                      [
                        _c("span", { attrs: { "aria-hidden": "true" } }, [
                          _vm._v("×")
                        ])
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" })
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  _c("div", { staticClass: "row mb-4" }, [
                    _c("div", { staticClass: "col-9 pl-3" }, [
                      _c(
                        "div",
                        { staticClass: "h5 d-inline mr-2 text-uppercase" },
                        [_vm._v(_vm._s(_vm.group_name_text))]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _vm.updateMsg
                    ? _c("div", { staticClass: "text-green" }, [
                        _vm._v(_vm._s(_vm.updateMsg))
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("form", [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v("Group Name")
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.group_name,
                              expression: "group_name"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: {
                                rules: {
                                  required: true,
                                  regex: _vm.nameRegex()
                                }
                              },
                              expression:
                                "{ rules: { required: true, regex: nameRegex() } }"
                            }
                          ],
                          ref: "group_name",
                          staticClass: "col-12 col-sm-12 ma-input-field",
                          attrs: {
                            type: "text",
                            id: "group_name",
                            name: "group_name",
                            placeholder: "Enter Group Name",
                            maxlength: "250",
                            autocomplete: "off"
                          },
                          domProps: { value: _vm.group_name },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.group_name = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("group_name", "required")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Group name is required")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.verrors.firstByRule("group_name", "regex")
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "margin-bottom-5 validate-warning-msg"
                              },
                              [_vm._v("Group name should only contain - and _")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.groupExists
                          ? _c("div", { staticClass: "text-red" }, [
                              _vm._v(_vm._s(_vm.groupExists))
                            ])
                          : _vm._e()
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-2" }, [
                      _c("div", { staticClass: "col-12" }, [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v("Accounts in Group")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row edit_row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _vm.groupLinkedAccountsResults.length > 0
                            ? _c(
                                "div",
                                { staticClass: "row_item_readonly" },
                                _vm._l(_vm.groupLinkedAccountsResults, function(
                                  accName,
                                  index
                                ) {
                                  return _c(
                                    "div",
                                    {
                                      key: index,
                                      staticClass: "row_data_border"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "linked_group_account_1"
                                        },
                                        [_vm._v(_vm._s(accName))]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "clearfix" })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "row_item_readonly justify-content-md-center"
                            },
                            [
                              _c("div", { staticClass: "text-blue m-4" }, [
                                _vm._v(_vm._s(_vm.getNoRecordText()))
                              ])
                            ]
                          )
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row mt-4" }, [
                      _c("div", { staticClass: "col-8" }, [
                        _c("label", { staticClass: "form-label" }, [
                          _vm._v("Add Accounts to Group")
                        ])
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-4" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.org_name,
                              expression: "org_name"
                            }
                          ],
                          ref: "org_name",
                          staticClass: "search_org_text",
                          attrs: {
                            type: "text",
                            name: "org name",
                            id: "org_name",
                            maxlength: "250"
                          },
                          domProps: { value: _vm.org_name },
                          on: {
                            keyup: function($event) {
                              if (
                                !$event.type.indexOf("key") &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              return _vm.setLocationFilterbyName($event)
                            },
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.org_name = $event.target.value
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass: "search-icon",
                            on: { click: _vm.setLocationFilterbyName }
                          },
                          [
                            _c("i", {
                              staticClass: "fa fa-search search_icons"
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row edit_row" }, [
                        _c("div", { staticClass: "col-12" }, [
                          _vm.locations.length > 0
                            ? _c(
                                "div",
                                { staticClass: "row_item_readonly" },
                                _vm._l(_vm.locations, function(item, aindex) {
                                  return _c(
                                    "div",
                                    {
                                      key: aindex,
                                      staticClass: "row_data_border"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "location_item_1" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "chkboxwrapper" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "custom-control custom-checkbox"
                                                },
                                                [
                                                  _c("input", {
                                                    directives: [
                                                      {
                                                        name: "model",
                                                        rawName: "v-model",
                                                        value:
                                                          _vm.accountsSelected,
                                                        expression:
                                                          "accountsSelected"
                                                      }
                                                    ],
                                                    staticClass:
                                                      "custom-control-input",
                                                    attrs: {
                                                      type: "checkbox",
                                                      name:
                                                        "assign_accounts_" +
                                                        aindex,
                                                      id:
                                                        "assign_accounts_" +
                                                        aindex
                                                    },
                                                    domProps: {
                                                      value: item.accId,
                                                      checked: Array.isArray(
                                                        _vm.accountsSelected
                                                      )
                                                        ? _vm._i(
                                                            _vm.accountsSelected,
                                                            item.accId
                                                          ) > -1
                                                        : _vm.accountsSelected
                                                    },
                                                    on: {
                                                      change: function($event) {
                                                        var $$a =
                                                            _vm.accountsSelected,
                                                          $$el = $event.target,
                                                          $$c = $$el.checked
                                                            ? true
                                                            : false
                                                        if (
                                                          Array.isArray($$a)
                                                        ) {
                                                          var $$v = item.accId,
                                                            $$i = _vm._i(
                                                              $$a,
                                                              $$v
                                                            )
                                                          if ($$el.checked) {
                                                            $$i < 0 &&
                                                              (_vm.accountsSelected = $$a.concat(
                                                                [$$v]
                                                              ))
                                                          } else {
                                                            $$i > -1 &&
                                                              (_vm.accountsSelected = $$a
                                                                .slice(0, $$i)
                                                                .concat(
                                                                  $$a.slice(
                                                                    $$i + 1
                                                                  )
                                                                ))
                                                          }
                                                        } else {
                                                          _vm.accountsSelected = $$c
                                                        }
                                                      }
                                                    }
                                                  }),
                                                  _vm._v(" "),
                                                  _c("label", {
                                                    staticClass:
                                                      "custom-control-label",
                                                    attrs: {
                                                      for:
                                                        "assign_accounts_" +
                                                        aindex
                                                    }
                                                  })
                                                ]
                                              )
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "location_item_2" },
                                        [_vm._v(_vm._s(item.accountName))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "location_item_3" },
                                        [
                                          _vm._v(
                                            _vm._s(item.city ? item.city : " ")
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "location_item_4" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              item.stateCode
                                                ? item.stateCode
                                                : " "
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "clearfix" })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.accountSelectedErrorMsg
                            ? _c("div", { staticClass: "text-error" }, [
                                _vm._v(_vm._s(_vm.accountSelectedErrorMsg))
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]),
                    _vm._v(" "),
                    _vm.loading == true
                      ? _c(
                          "div",
                          { staticClass: "text-center pt-4" },
                          _vm._l(10, function(option) {
                            return _c("div", { staticClass: "row ml-1" }, [
                              _c(
                                "div",
                                {
                                  staticClass: "res_heading_1",
                                  staticStyle: { "padding-left": "0px" }
                                },
                                [_c("PuSkeleton", { attrs: { count: 1 } })],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "res_heading_2",
                                  staticStyle: { "padding-left": "10px" }
                                },
                                [_c("PuSkeleton", { attrs: { count: 1 } })],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-12 p-0" }, [
                                _c("div", { staticClass: "custom_hr" })
                              ])
                            ])
                          }),
                          0
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row justify-content-md-end mr-1" },
                      [
                        _vm.rows > 25
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "overflow-auto float-right pagination-wrapper"
                              },
                              [
                                _c("b-pagination", {
                                  attrs: {
                                    "total-rows": _vm.rows,
                                    "per-page": _vm.perPage,
                                    "first-text": "First",
                                    "prev-text": "Prev",
                                    "next-text": "Next",
                                    "last-text": "Last",
                                    "hide-goto-end-buttons": false
                                  },
                                  on: {
                                    input: function($event) {
                                      return _vm.showLocationsPaginated()
                                    }
                                  },
                                  model: {
                                    value: _vm.currentPage,
                                    callback: function($$v) {
                                      _vm.currentPage = $$v
                                    },
                                    expression: "currentPage"
                                  }
                                })
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "row submit_row justify-content-md-center"
                      },
                      [
                        _c("div", { staticClass: "col-6" }, [
                          _c(
                            "button",
                            {
                              staticClass:
                                "btn btn-sm btn-blue saveBtn text-center",
                              attrs: { type: "button" },
                              on: { click: _vm.saveGroup }
                            },
                            [_vm._v("Save")]
                          )
                        ])
                      ]
                    )
                  ])
                ])
              ])
            ]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-63f9d308", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-63f9d308","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/enterpriseadmin/existing_group.vue
// module id = null
// module chunks = 